import { render } from "./ToolButton.vue?vue&type=template&id=82d80770"
import script from "./ToolButton.vue?vue&type=script&lang=js"
export * from "./ToolButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__